import { createContext, useContext } from "react";

/**
 * This context stores a boolean indicating whether to render an HTML editor within a separate domain/iframe to prevent XSS.
 *
 * This is true by default, and should only be opted-out carefully in non-production environments.
 */
export const UseEditorDomainContext = createContext(true);

/**
 * Hook to determine if an editor should be rendered in the separate editor domain.
 *
 * This will return true, unless an ancestor in the React tree changes this context to opt out of the domain.
 */
export const useEditorDomain = () => useContext(UseEditorDomainContext);
